import React, { useState, useEffect } from "react";
import "./agendamento.css";
import ListaAgendados from "./Lista-de-Agendamentos/listaAgendados";

import { Agendamento } from "../../../API/AgendarEvento";
import { getIluminacao } from "../../../API/getIluminação";
import getUnidadesExaustor from "../../../API/getUnidadesExaustor";

function TelaTemporizacao() {
  const [grupos, setGrupos] = useState([]);
  const [exaustores, setExaustores] = useState([]);
  const [grupoLuz, setGrupoLuz] = useState("");
  const [descricaoLuz, setDescricaoLuz] = useState("");
  const [inicioLuz, setInicioLuz] = useState("");
  const [fimLuz, setFimLuz] = useState("");
  const [onValueLuz, setOnValueLuz] = useState("ON");
  const [offValueLuz, setOffValueLuz] = useState("OFF");

  const [grupoExaustor, setGrupoExaustor] = useState("");
  const [descricaoExaustor, setDescricaoExaustor] = useState("");
  const [inicioExaustor, setInicioExaustor] = useState("");
  const [fimExaustor, setFimExaustor] = useState("");
  const [onValueExaustor, setOnValueExaustor] = useState("");
  const [offValueExaustor, setOffValueExaustor] = useState("");

  const [refreshFlag, setRefreshFlag] = useState(false);

  useEffect(() => {
    getIluminacao().then((data) => {
      setGrupos(data); // Atualiza os grupos com os dados vindos da API
    });

    getUnidadesExaustor().then((data) => {
      const exaustoresPrincipais = data.map((exaustor) => ({
        id: exaustor.id,
        status: exaustor.status,
        timer: exaustor.timer,
        unidades: exaustor.unidades,
        on: exaustor.on, // Comando para ligar o exaustor
        off: exaustor.off, // Comando para desligar o exaustor
        descricao: `Exaustor ${exaustor.id}`,
      }));
      setExaustores(exaustoresPrincipais); // Atualiza os exaustores principais
    });
  }, []);

  const handleSelectChange = (e, setGrupo, setDescricao, setOnValue, setOffValue) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    setGrupo(e.target.value); // Define o grupo selecionado
    setDescricao(selectedOption.text); // Define a descrição do grupo selecionado
    setOnValue(selectedOption.getAttribute("data-on")); // Define o comando ON
    setOffValue(selectedOption.getAttribute("data-off")); // Define o comando OFF
  };

  const temporizar = async () => {
    if ((grupoLuz === "" || inicioLuz === "" || fimLuz === "") && (grupoExaustor === "" || inicioExaustor === "" || fimExaustor === "")) {
      alert("Preencha todos os campos.");
      return;
    }
    if (grupoLuz !== "" && inicioLuz !== "" && fimLuz !== "") {
      await Agendamento(descricaoLuz, inicioLuz, fimLuz, onValueLuz, offValueLuz, "Iluminação");
      alert(`Agendamento salvo para: ${descricaoLuz}`);
      setInicioLuz("");
      setFimLuz("");
    }
    if (grupoExaustor !== "" && inicioExaustor !== "" && fimExaustor !== "") {
      await Agendamento(descricaoExaustor, inicioExaustor, fimExaustor, onValueExaustor, offValueExaustor, "Exaustor");
      alert(`Agendamento salvo para: ${descricaoExaustor}`);
      setInicioExaustor("");
      setFimExaustor("");
    }
    setRefreshFlag(!refreshFlag); // Força a re-renderização de ListaAgendados
  };

  return (
    <div id="TelaTemporizacao-mobile">
      <div id="temporizacao-mobile">
        <h1>Agendamentos Diários</h1>
        <div id="temporizacaoContent-mobile">
          <div id="temporizacaoContent1-mobile">
            <h2>Luzes</h2>
            <div id="temporizacaoContent1-1-mobile">
              <label>Grupo</label>
              <select
                id="selectGrupoLuz-mobile"
                value={grupoLuz}
                onChange={(e) => handleSelectChange(e, setGrupoLuz, setDescricaoLuz, setOnValueLuz, setOffValueLuz)}
              >
                <option value="" disabled>Selecione um grupo</option>
                {grupos.map((grupo) => (
                  <option
                    key={grupo.groupid}
                    value={grupo.groupid}
                    data-on={grupo.oncommand}
                    data-off={grupo.offcommand}
                  >
                    {grupo.descricao}
                  </option>
                ))}
              </select>
              <label htmlFor="inicioLuz">Início</label>
              <input type="time" id="inicioLuz-mobile" value={inicioLuz} onChange={(e) => setInicioLuz(e.target.value)} />
              <label htmlFor="fimLuz">Fim</label>
              <input type="time" id="fimLuz-mobile" value={fimLuz} onChange={(e) => setFimLuz(e.target.value)} />
            </div>
          </div>
          <div id="temporizacaoContent2-mobile">
            <h2>Exaustor</h2>
            <div id="temporizacaoContent2-1-mobile">
              <label>Grupo</label>
              <select
                id="selectGrupoExaustores-mobile"
                value={grupoExaustor}
                onChange={(e) => handleSelectChange(e, setGrupoExaustor, setDescricaoExaustor, setOnValueExaustor, setOffValueExaustor)}
              >
                <option value="" disabled>Selecione um exaustor</option>
                {exaustores.map((exaustor) => (
                  <option
                    key={exaustor.id}
                    value={exaustor.id}
                    data-on={exaustor.on}
                    data-off={exaustor.off}
                  >
                    {exaustor.descricao}
                  </option>
                ))}
              </select>
              <label htmlFor="inicioExaustor">Início</label>
              <input type="time" id="inicioExaustor-mobile" value={inicioExaustor} onChange={(e) => setInicioExaustor(e.target.value)} />
              <label htmlFor="fimExaustor">Fim</label>
              <input type="time" id="fimExaustor-mobile" value={fimExaustor} onChange={(e) => setFimExaustor(e.target.value)} />
            </div>
          </div>
        </div>
        <button id="btnSalvar-mobile" onClick={temporizar}>
          Salvar
        </button>
      </div>
      <div id="Lista-agendados-mobile">
        <ListaAgendados refreshFlag={refreshFlag} />
      </div>
    </div>
  );
}

export default TelaTemporizacao;